import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, PropSync, Watch, Prop } from 'vue-property-decorator';
import CalendarNav from './CalendarNav.vue';
import { pageForDate, isMonthDisable } from './utils/utils';

var MonthSelector = /*#__PURE__*/function (_Vue) {
  _inherits(MonthSelector, _Vue);

  var _super = _createSuper(MonthSelector);

  function MonthSelector() {
    var _this;

    _classCallCheck(this, MonthSelector);

    _this = _super.apply(this, arguments);
    _this.yearIndex = 2020;
    return _this;
  }

  _createClass(MonthSelector, [{
    key: "onYearChange",
    value: function onYearChange() {
      this.yearIndex = this.year;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.yearIndex = this.year;
      this.$refs.monthSelector.focus();
    }
  }, {
    key: "getItemClasses",
    value: function getItemClasses(item) {
      var isActive = item.isActive,
          isCurrent = item.isCurrent,
          isDisable = item.isDisable;
      var classes = ['grid-item'];

      if (isDisable) {
        classes.push('disable');
      }

      if (isActive) {
        classes.push('active');
      } else if (isCurrent) {
        classes.push('current');
      }

      return classes;
    }
  }, {
    key: "monthClick",
    value: function monthClick(month, isDisable) {
      if (isDisable) return;
      this.syncedPage = {
        month: month,
        year: this.yearIndex
      };
    }
  }, {
    key: "movePrev",
    value: function movePrev() {
      this.yearIndex--;
    }
  }, {
    key: "moveNext",
    value: function moveNext() {
      this.yearIndex++;
    }
  }, {
    key: "monthItems",
    get: function get() {
      var _pageForDate = pageForDate(new Date()),
          thisMonth = _pageForDate.month,
          thisYear = _pageForDate.year;

      var items = [];

      for (var i = 0; i < 12; i++) {
        var month = i + 1;
        var item = {
          label: month,
          isActive: month === this.month && this.yearIndex === this.year,
          isCurrent: month === thisMonth && this.yearIndex === thisYear,
          isDisable: isMonthDisable({
            year: this.yearIndex,
            month: month
          }, this.minDate)
        };
        items.push(item);
      }

      return items;
    }
  }, {
    key: "year",
    get: function get() {
      return this.syncedPage ? this.syncedPage.year || 2020 : 2020;
    }
  }, {
    key: "month",
    get: function get() {
      return this.syncedPage ? this.syncedPage.month || 9 : 9;
    }
  }]);

  return MonthSelector;
}(Vue);

__decorate([PropSync('page', {
  type: Object,
  default: function _default() {
    return {
      month: 9,
      year: 2020
    };
  }
})], MonthSelector.prototype, "syncedPage", void 0);

__decorate([Prop({
  type: [String, Date]
})], MonthSelector.prototype, "minDate", void 0);

__decorate([Watch('year')], MonthSelector.prototype, "onYearChange", null);

MonthSelector = __decorate([Component({
  components: {
    CalendarNav: CalendarNav
  }
})], MonthSelector);
export default MonthSelector;